<script lang="ts">
  import {
    createEventDispatcher,
    getContext,
    onDestroy,
    onMount,
    tick,
  } from "svelte";
  import {
    getSvelteContext,
    type MapDataEvent,
    type MapEvent,
  } from "./mapping";
  import type {
    MapGeoJSONFeature,
    MapMouseEvent,
    MapSourceDataEvent,
    VectorGLMap,
  } from "./mapping";
  import throttle from "lodash-es/throttle";

  const eventing = createEventDispatcher();

  const { styledmap } = getSvelteContext();

  let MAP: VectorGLMap;

  //export let source: string | undefined | null = null;
  //export let sourceLayer: string | undefined | null = null;
  export let state:
    | Record<string, any>
    | ((feature: MapGeoJSONFeature | GeoJSON.Feature) => Record<string, any>) =
    null;
  export let filter: any[] | undefined | null = [
    "all",
    ["==", ["geometry-type"], "Polygon"],
    ["has", "ref:boss:subject"],
  ];

  function processSelection(
    $map: VectorGLMap,
    $features: MapGeoJSONFeature[],
    $state:
      | Record<string, any>
      | ((feature: MapGeoJSONFeature | GeoJSON.Feature) => Record<string, any>)
  ) {
    // console.log(
    //   "processSelectionFeatures=",
    //   $map.querySourceFeatures(source),
    //   $map.getSource(source),
    //   selectable,
    //   selected
    // );
    // const source = $map.getSource("selection") as GeoJSONSource;
    // const data = source?.serialize()?.data;
    // console.log("data=", data);

    //console.log("features=", source, $features);
    for (const feature of $features) {
      //console.log("feature=", feature);
      if (!feature.id) continue;
      if (!feature.source) continue;

      //if ("Polygon" !== feature.geometry.type) continue;
      const featureState =
        state instanceof Function
          ? state(feature)
          : state?.[feature.properties?.["ref:boss:subject"]] ?? state?.["*"];

      //if (featureSelectable) console.log("selectable feature=", feature);

      //console.log("feature=", feature, featureState);

      $map.setFeatureState(feature, featureState);
    }
  }

  function onclick(e: MapMouseEvent) {
    const features = e.target
      .queryRenderedFeatures(e.point)
      .filter((feature) => feature.state?.selectable);

    for (const feature of features) {
      eventing("select", feature);
    }
  }

  function selection(
    $map: VectorGLMap,
    $filter: any[],
    $state:
      | Record<string, any>
      | ((feature: MapGeoJSONFeature | GeoJSON.Feature) => Record<string, any>),
    $source: string = null
  ) {
    if (!$map) {
      console.log("no usable map yet, can't query");
      return;
    }
    processSelection(
      $map,
      $source
        ? $map
            .querySourceFeatures($source, {
              filter: $filter,
            })
            .map(function (f) {
              if (!f.source) f.source = $source;
              return f;
            })
        : $map.queryRenderedFeatures(null, {
            filter: $filter,
          }),
      $state
    );
  }

  const throttled = throttle(selection, 1 * 1000, {
    leading: true,
  });

  function onidle(e: MapEvent) {
    //console.log("selectable onidle", e);
    if (!e.target.isStyleLoaded()) return; // don't use idle while not loaded
    //onsole.log("about to selectable onidle");
    throttled(e.target, filter, state);
  }

  function onsourcedata(e: MapSourceDataEvent) {
    //console.log("selectable onsourcedata=", e.sourceId, e.isSourceLoaded);
    if (e.isSourceLoaded)
      tick().then(() => selection(e.target, filter, state, e.sourceId));
  }

  function init($map: VectorGLMap) {
    //console.log("init for map", $map);
    cleanup(); // cleanup previous map
    MAP = $map; // set

    // events
    MAP?.on("sourcedata", onsourcedata);
    //MAP?.on("idle", onidle);
    //MAP?.on("click", onclick);
  }
  function cleanup() {
    if (!MAP) return; // no map to cleanup

    // events
    MAP?.off("sourcedata", onsourcedata);
    MAP?.off("idle", onidle);
    //MAP?.off("click", onclick);

    selection(MAP, filter, {});

    // set
    MAP = null;
  }

  $: init($styledmap);

  onMount(function () {
    //const unsubscribe = map.subscribe(init);
    return function destroy() {
      cleanup();
      //unsubscribe();
    };
  });

  //   onMount(function () {
  //     map.on("sourcedata", onsourcedata);
  //     map.on("idle", onidle);
  //     map.on("click", onclick);

  //     return function destroy() {
  //       map?.off("sourcedata", onsourcedata);
  //       map?.off("idle", onidle);
  //       map?.off("click", onclick);
  //     };
  //   });

  $: selection($styledmap, filter, state);
</script>

<slot />
